/**
 * @generated SignedSource<<b464de2e36a97e276223d17e158fe91e>>
 * @relayHash a01a98fbbbbe9d0486e6cc80c7ae6251
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ea3963174a116e415e7e2e0f67347f8873b9776cf30483e6f91d2dbcc78f94a0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavJiraInnerQuery } from './HorizontalNavJiraInnerQuery.graphql';

import isJiraCustomTemplatesUxEnabled_provider from '@atlassian/jira-relay-provider/src/jira-custom-templates-ux-fg.relayprovider';
import showTeamButton_provider from '@atlassian/jira-relay-provider/src/jira-team-button.relayprovider';

const node: PreloadableConcreteRequest<HorizontalNavJiraInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ea3963174a116e415e7e2e0f67347f8873b9776cf30483e6f91d2dbcc78f94a0",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": isJiraCustomTemplatesUxEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": showTeamButton_provider
    }
  }
};

export default node;
